import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import {
  Home,
  Users,
  BookOpen,
  Layers,
  Bell,
  Search,
  ShieldAlert,
  Flag,
  Briefcase,
  UserCheck,
  FileText,
  KeyRound,
  CreditCard,
  ShieldCheck,
  ListChecks,
  FileCheck2,
  Wallet,
  FolderArchive,
  Receipt,
  Tag,
  User,
  GraduationCap,
  Building2,
  Share2,
} from "lucide-react";
import DashboardLayout from "../dashboard/DashboardLayout";
import NavItem, { NavSection } from "../dashboard/components/navItem";
import ScrollToTop from "../../utils/scrollToTop";
import RoleSwitcher from "../../components/layout/RoleSwitcher";

const SuperAdminDashboardLayout = () => {
  const location = useLocation();

  useEffect(() => {
    localStorage.setItem("from", location.pathname);
  }, [location.pathname]);

  const SidebarNav = (
    <>
      <NavItem
        to="/superadmin/dashboard"
        icon={Home}
        label="Console Overview"
        end
      />

      <NavSection label="Governance & Security" />
      <NavItem
        to="/superadmin/dashboard/users"
        icon={Users}
        label="User Management"
        end
      />
      <NavItem
        to="/superadmin/dashboard/roles"
        icon={KeyRound}
        label="Roles & Permissions"
        end
      />
      <NavItem
        to="/superadmin/dashboard/reports"
        icon={Flag}
        label="Audit Reports"
        end
      />

      <NavSection label="Academic Operations" />
      <NavItem
        to="/superadmin/dashboard/courses"
        icon={BookOpen}
        label="Course Library"
        end
      />
      <NavItem
        to="/superadmin/dashboard/tracks"
        icon={Layers}
        label="Career Tracks"
        end
      />
      <NavItem
        to="/superadmin/dashboard/enrollments"
        icon={GraduationCap}
        label="Admissions & Enrollment"
        end
      />

      <NavSection label="Operations & Logistics" />
      <NavItem
        to="/superadmin/dashboard/staff-jobs"
        icon={Briefcase}
        label="Staff Assignments"
        end
      />
      <NavItem
        to="/superadmin/dashboard/visitors"
        icon={UserCheck}
        label="Visitor Log"
        end
      />
      <NavItem
        to="/superadmin/dashboard/price-list"
        icon={Tag}
        label="Company Price List"
        end
      />

      <NavSection label="Finance & Treasury" />
      <NavItem
        to="/superadmin/dashboard/payments"
        icon={CreditCard}
        label="Finance & Payouts"
        end
      />
      <NavItem
        to="/superadmin/dashboard/income-expenditure"
        icon={Receipt}
        label="Income & Expenditure"
        end
      />

      <NavSection label="Editorial & Media" />
      <NavItem
        to="/superadmin/dashboard/blog"
        icon={FileText}
        label="Blog Management"
        end
      />
      <NavItem
        to="/superadmin/dashboard/media-library"
        icon={FolderArchive}
        label="Media Library"
        end
      />
      <NavItem
        to="/superadmin/dashboard/social-broadcast"
        icon={Share2}
        label="Social Broadcast"
        end
      />

      <NavSection label="Verification Services" />
      <NavItem
        to="/superadmin/dashboard/verification"
        icon={ShieldCheck}
        label="Verification Center"
        end
      />
      <NavItem
        to="/superadmin/dashboard/verification/services"
        icon={ListChecks}
        label="Services Catalog"
        end
      />
      <NavItem
        to="/superadmin/dashboard/verification/logs"
        icon={FileCheck2}
        label="Verification Logs"
        end
      />
      <NavItem
        to="/superadmin/dashboard/verification/wallet"
        icon={Wallet}
        label="Verification Wallet"
        end
      />

      <NavSection label="System & Alerts" />
      <NavItem
        to="/superadmin/dashboard/notifications"
        icon={Bell}
        label="Notifications"
        end
      />

      <NavSection label="Account & Preferences" />
      <NavItem
        to="/superadmin/dashboard/company-settings"
        icon={Building2}
        label="Company Settings"
        end
      />
      <NavItem
        to="/superadmin/dashboard/profile"
        icon={User}
        label="Profile & Settings"
        end
      />
    </>
  );

  const TopBarAddons = (
    <div className="cht-flex cht-items-center cht-gap-2">
      <RoleSwitcher />
      <div className="cht-hidden md:cht-flex cht-relative cht-mr-2 cht-group">
        <Search
          className="cht-absolute cht-left-3 cht-top-1/2 -cht-translate-y-1/2 cht-text-gray-400 group-focus-within:cht-text-[#3e57da] cht-transition-colors"
          size={16}
        />
        <input
          type="text"
          placeholder="Root system search..."
          className="cht-w-40 lg:cht-w-64 cht-bg-white/50 cht-border cht-border-gray-200/50 cht-rounded-xl cht-py-2 cht-pl-9 cht-pr-4 cht-text-xs cht-font-medium cht-focus:ring-2 cht-focus:ring-[#3e57da]/10 cht-focus:border-[#3e57da] cht-outline-none cht-transition-all"
        />
      </div>

      <div className="cht-flex cht-items-center cht-gap-1.5 cht-px-3.5 cht-py-1.5 cht-bg-purple-50 cht-border cht-border-purple-200 cht-rounded-full cht-text-purple-700 cht-text-[10px] cht-font-black cht-uppercase cht-tracking-wider">
        <ShieldAlert size={12} className="cht-[#3e57da]" />
        SuperAdmin Mode
      </div>
    </div>
  );

  return (
    <>
      <ScrollToTop />
      <DashboardLayout
        sidebarNavContent={SidebarNav}
        topBarAddons={TopBarAddons}
      >
        <Outlet />
      </DashboardLayout>
    </>
  );
};

export default SuperAdminDashboardLayout;
